/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';

const hostUrl = "";

export default {
    
    // send custom emails to clients/counsellors
    sendCustomEmail: (data) => {
        return axios.post(hostUrl + '/api/admin/sendCustomEmail', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getDemoUsers: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/demoUsers', { params: { limit: limit, page: page, query: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateDemoUsers: (user) => {
        return axios.put(hostUrl + '/api/admin/demoUser', user)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getForms: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/userForms', { params: { limit: limit, page: page, query: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    addForm: (form) => {
        return axios.post(hostUrl + '/api/admin/userForm', form)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateForm: (form) => {
        return axios.put(hostUrl + '/api/admin/userForm', form)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getFormType: () => {
        return axios.get(hostUrl + '/api/admin/userFormType')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateFormType: (form) => {
        return axios.put(hostUrl + '/api/admin/userFormType', form)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    deleteForm: (id) => {
        return axios.delete(hostUrl + '/api/admin/userForm/' + id)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    setActiveStatusForm: (formId, isActive) => {
        return axios.put(hostUrl + '/api/admin/activateDeactivateForm', { formId, isActive })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getFormQuestions: (form, limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/userFormQuestions', { params: { form: form, limit: limit, page: page, query: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    addFormQuestion: (question) => {
        return axios.post(hostUrl + '/api/admin/userFormQuestion', question)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateFormQuestion: (question) => {
        return axios.put(hostUrl + '/api/admin/userFormQuestion', question)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    deleteFormQuestion: (id) => {
        return axios.delete(hostUrl + '/api/admin/userFormQuestion/' + id)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get admin dashboard site variables
    getDashboardData: () => {
        return axios.get(hostUrl + '/api/admin/sitevariables')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the userTitles site variable
    setUserTitles: (userTitles) => {
        return axios.post(hostUrl + '/api/admin/userTitles', { userTitles })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the providerLanguages site variable
    setProviderLanguages: (providerLanguages) => {
        return axios.post(hostUrl + '/api/admin/providerLanguages', { providerLanguages })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the providerSpecialities site variable
    setProviderSpecialities: (providerSpecialities) => {
        return axios.post(hostUrl + '/api/admin/providerSpecialities', { providerSpecialities })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the minimumAgeForClient site variable
    setMinimumAgeForClient: (minimumAgeForClient) => {
        return axios.post(hostUrl + '/api/admin/minimumAgeForClient', { minimumAgeForClient })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the timeSlotSize site variable
    setTimeSlotSize: (timeSlotSize) => {
        return axios.post(hostUrl + '/api/admin/timeSlotSize', { timeSlotSize })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the GSTPercentage site variable
    setGSTPercentage: (GSTPercentage) => {
        return axios.post(hostUrl + '/api/admin/GSTPercentage', { GSTPercentage })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the advanceBookingLimit site variable
    setAdvanceBookingLimit: (advanceBookingLimit) => {
        return axios.post(hostUrl + '/api/admin/advanceBookingLimit', { advanceBookingLimit })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the minimum service charges site variable
    setMinimumServiceCharges: (minimumServiceCharges) => {
        return axios.post(hostUrl + '/api/admin/minimumServiceCharges', { minimumServiceCharges })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the minimum report charge site variable
    setMinimumReportCharge: (minimumReportCharge) => {
        return axios.post(hostUrl + '/api/admin/minimumReportCharge', { minimumReportCharge })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update the subscriptionPlanRange site variable
    setSubscriptionPlanRange: (subscriptionPlanRange) => {
        return axios.post(hostUrl + '/api/admin/subscriptionPlanRange', subscriptionPlanRange)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // register a provider
    registerProvider: (provider) => {
        return axios.post(hostUrl + '/api/admin/registerProvider', provider)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // replace a provider
    replaceProvider: (clientEmail, providerId) => {
        return axios.post(hostUrl + '/api/admin/replaceProvider', { clientEmail, providerId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of clients
    getClients: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/clients', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of new providers
    getNewProviders: () => {
        return axios.get(hostUrl + '/api/admin/newProviders')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of providers
    getProviders: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/providers', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of providerPayments
    getProviderPayments: (searchData) => {
        return axios.post(hostUrl + '/api/admin/providerPayments', searchData)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // activateDeactivate a client
    setActiveStatusClient: (clientId, isActive) => {
        return axios.post(hostUrl + '/api/admin/activateDeactivateClient', { clientId, isActive })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // activateDeactivate a provider
    setActiveStatusProvider: (providerId, isActive) => {
        return axios.post(hostUrl + '/api/admin/activateDeactivateProvider', { providerId, isActive })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of pending payments
    getPendingPayments: () => {
        return axios.get(hostUrl + '/api/admin/pendingPayments')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    // get list of completed payments
    getCompletedPayments: () => {
        return axios.get(hostUrl + '/api/admin/completedPayments')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    // mark payment as processed
    markPaymentProcessed: (providerEmail, fromDate) => {
        return axios.post(hostUrl + '/api/admin/markPaymentProcessed', { providerEmail, fromDate })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    // get list of coupons
    getCoupons: (limit, page, description, from, to) => {
        return axios.get(hostUrl + '/api/admin/coupons', { params: { limit, page, description, from, to } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add coupon
    addCoupons: (data) => {
        return axios.post(hostUrl + '/api/admin/addCoupon', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of sessions
    getSessions: (limit, page, client, provider, mode, from, to, status) => {
        return axios.get(hostUrl + '/api/admin/sessions', { params: { limit: limit, page: page, client: client, provider: provider, mode: mode, from: from, to: to, status: status } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get session detail
    getSessionDetail: (id) => {
        return axios.get(hostUrl + '/api/admin/sessionDetail', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of audits
    getAudits: (limit, page, type, from, to, table) => {
        return axios.get(hostUrl + '/api/admin/audits', { params: { limit: limit, page: page, type: type, from: from, to: to, table: table } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get data of audit
    getAuditData: (table, id) => {
        return axios.post(hostUrl + '/api/admin/auditData', { document: table, id: id })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of refunds
    getRefunds: (limit, page, from, to, status) => {
        return axios.get(hostUrl + '/api/admin/refunds', { params: { limit, page, from, to, status } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // set refund as complete
    // modal.data.sessionId, modal.data.dateTime, modal.data.transactionId, modal.data.amount
    setRefund: (data) => {
        return axios.post(hostUrl + '/api/admin/setRefundStatus', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of giftVouchers
    getGiftVouchers: (limit, page, from, to) => {
        return axios.get(hostUrl + '/api/admin/giftVouchers', { params: { limit, page, from, to } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add giftVoucher
    addGiftVoucher: (data) => {
        return axios.post(hostUrl + '/api/admin/addGiftVoucher', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // send giftVoucher to user
    sendGiftVoucher: (id) => {
        return axios.put(hostUrl + '/api/admin/sendGiftVoucher', { id })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    setMaintenanceStatus: (status) => {
        return axios.put(hostUrl + '/api/admin/maintenanceStatus', status)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    setPolicyNConditionStatus: (type, effectiveFrom) => {
        return axios.put(hostUrl + '/api/admin/policyNConditionStatus', { type: type, effectiveFrom: effectiveFrom })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },




    // Provider Subscription Plans
    postProviderSubscriptionPlan: (planName, planServiceDetails, planAmount) => {
        return axios.post(hostUrl + '/api/admin/provider/subscriptionPlan', { planName, planServiceDetails, planAmount })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    putProviderSubscriptionPlan: (id, planName, planServiceDetails, planAmount) => {
        return axios.put(hostUrl + '/api/admin/provider/subscriptionPlan', { id, planName, planServiceDetails, planAmount })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    deleteProviderSubscriptionPlan: (id) => {
        return axios.delete(hostUrl + '/api/admin/provider/subscriptionPlan', { params: { id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getProviderSubscriptionPlan: (id) => {
        return axios.get(hostUrl + '/api/admin/provider/subscriptionPlan', { params: { id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getProviderSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/admin/provider/subscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    // Organisation Subscription Plans
    postOrganisationSubscriptionPlan: (planName, planServiceDetails, planAmount) => {
        return axios.post(hostUrl + '/api/admin/organisation/subscriptionPlan', { planName, planServiceDetails, planAmount })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    putOrganisationSubscriptionPlan: (id, planName, planServiceDetails, planAmount) => {
        return axios.put(hostUrl + '/api/admin/organisation/subscriptionPlan', { id, planName, planServiceDetails, planAmount })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    deleteOrganisationSubscriptionPlan: (id) => {
        return axios.delete(hostUrl + '/api/admin/organisation/subscriptionPlan', { params: { id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getOrganisationSubscriptionPlan: (id) => {
        return axios.get(hostUrl + '/api/admin/organisation/subscriptionPlan', { params: { id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getOrganisationSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/admin/organisation/subscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    // Approve/Unapprove Organisations
    getUnapprovedOrganisations: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/organisation/unapproved', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postApproveOrganisation: (organisationId) => {
        return axios.post(hostUrl + '/api/admin/organisation/approve', { organisationId: organisationId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postUnApproveOrganisation: (organisationId) => {
        return axios.post(hostUrl + '/api/admin/organistion/unapprove', { organisationId: organisationId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    // Approve/Unapprove Providers
    getUnapprovedProviders: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/provider/unapproved', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postApproveProvider: (providerId) => {
        return axios.post(hostUrl + '/api/admin/provider/approve', { providerId: providerId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postUnApproveProvider: (providerId) => {
        return axios.post(hostUrl + '/api/admin/provider/unapprove', { providerId: providerId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },




    getServices: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/services', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getService: (id) => {
        return axios.get(hostUrl + '/api/admin/service', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postService: (serviceDetails) => {
        return axios.post(hostUrl + '/api/admin/service', { serviceDetails: serviceDetails })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    putService: (serviceDetails, id) => {
        return axios.put(hostUrl + '/api/admin/service', { serviceDetails: serviceDetails, id: id })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getServiceRequests: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/serviceRequests', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getScrapeProviderProfiles: (limit, page, search, profileStatus) => {
        return axios.get(hostUrl + '/api/admin/scrapeProviderProfiles', { params: { limit: limit, page: page, search: search, profileStatus: profileStatus } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postScrapeProviderProfiles: (profiles) => {
        return axios.post(hostUrl + '/api/admin/scrapeProviderProfiles', { profiles: profiles })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    setActiveStatusScrapeProvider: (uniqueId, profileStatus) => {
        return axios.put(hostUrl + '/api/admin/scrapeProviderProfilesStatus', { uniqueId, profileStatus })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    putProfiles: (profile) => {
        return axios.put(hostUrl + '/api/admin/scrapeProviderProfile', { profile })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProfile: (uniqueId) => {
        return axios.get(hostUrl + '/api/admin/scrapeProviderProfile', { uniqueId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProfileRequests: (limit, page, search, requestStatus) => {
        return axios.get(hostUrl + '/api/admin/claimProviderProfileRequests', { params: { limit: limit, page: page, search: search, requestStatus: requestStatus } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    assignCounsellor: (profile) => {
        return axios.post(hostUrl + '/api/admin/assignProviderProfile', profile)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postScrapeProviderSendInvite: (uniqueId) => {
        return axios.post(hostUrl + '/api/admin/scrapeProviderSendInvite', { uniqueId: uniqueId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getProvidersOnHome: () => {
        return axios.get(hostUrl + '/api/admin/providersOnHome')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postProvidersOnHome: (listOfProvidersOnHome) => {
        return axios.post(hostUrl + '/api/admin/providersOnHome', { listOfProvidersOnHome })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    // get list of transactions
    getTransactions: (limit, page, type, from, to, status) => {
        return axios.get(hostUrl + '/api/admin/transactions', { params: { limit: limit, page: page, type: type, from: from, to: to, status: status } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get detail of transaction
    getTransactionDetail: (type, id) => {
        return axios.get(hostUrl + '/api/admin/transactionDetail', { type: type, id: id })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    getFAQs: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/faqs', { params: { limit: limit, page: page, question: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getFAQ: (id) => {
        return axios.get(hostUrl + '/api/admin/faq', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postFAQ: (orderNo, type, question, answer) => {
        return axios.post(hostUrl + '/api/admin/faq', { orderNo, type, question, answer })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    putFAQ: (id, orderNo, type, question, answer) => {
        return axios.put(hostUrl + '/api/admin/faq', { id, orderNo, type, question, answer })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    deleteFAQ: (id) => {
        return axios.delete(hostUrl + '/api/admin/faq/' + id)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getPolicy: (type) => {
        return axios.get(hostUrl + '/api/admin/policy/' + type)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    savePolicy: (type, content) => {
        return axios.post(hostUrl + '/api/admin/policy', { type: type, content: content })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getProviderForms: (limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/providerForms', { params: { limit: limit, page: page, query: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    addProviderForm: (form) => {
        return axios.post(hostUrl + '/api/admin/ProviderForm', form)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateProviderForm: (form) => {
        return axios.put(hostUrl + '/api/admin/providerForm', form)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    deleteProviderForm: (id) => {
        return axios.delete(hostUrl + '/api/admin/providerForm/' + id)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProviderFormQuestions: (form, limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/providerFormQuestions', { params: { form: form, limit: limit, page: page, query: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    addProviderFormQuestion: (question) => {
        return axios.post(hostUrl + '/api/admin/providerFormQuestion', question)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateProviderFormQuestion: (question) => {
        return axios.put(hostUrl + '/api/admin/providerFormQuestion', question)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    deleteProviderFormQuestion: (id) => {
        return axios.delete(hostUrl + '/api/admin/providerFormQuestion/' + id)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProviderFormResponses: (formId, limit, page, query) => {
        return axios.get(hostUrl + '/api/admin/providerFormResponses', { params: { formId: formId, limit: limit, page: page, query: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

}